
angular.module('dybStudentComponents', [])